<small
  *ngIf="hint && !error"
  id="{{ controlName }}-hint"
  class="block custom-form-field__hint"
>
  {{ hint }}
</small>
<small
  class="p-error block custom-form-field__error"
>
  {{ error | translate }}
</small>

